import BigNumber from 'bignumber.js';

export function applyPrecision(
  content: BigNumber.Value,
  precision: number,
  withApproximatePrefix = false,
): string {
  const bn = new BigNumber(content);
  if (bn.isNaN()) return 'Unknown';

  const result = bn.toFixed(precision, BigNumber.ROUND_DOWN);

  let prefix = '';

  if (withApproximatePrefix && !bn.isZero() && Number(result) === 0) {
    prefix = '~';
  }

  return `${prefix}${result}`;
}
